import type { SanityPageBuilderSection, SanityPageBuilderSocialShareSection } from "@ouster/shared";
import { SocialShareBlockView } from "~/features/blocks/inventory/social-share";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderSocialShareSection;
  };
};
export function SanitySocialShareSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  return <SocialShareBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={sectionContent.text} />;
}